"use client";

import { ListSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedListSection from "../Components/GeneratedListSection";

const List: FC<ListSectionProps> = (props) => {
  return <GeneratedListSection {...props} />;
};

export default List;
